import { useEffect } from 'react';
import { useLocalSearchParams, useNavigation } from 'expo-router';
import { useAuth } from '@/hooks/useAuth';
import { useConversations } from '@/hooks/useConversations';
import { ConversationView } from '@/components/ConversationView';

export default function PersonalConversationScreen() {
  const { conversationId } = useLocalSearchParams<{ conversationId: string }>();
  const { profile } = useAuth();
  const navigation = useNavigation();
  const { conversations } = useConversations(profile?.id ?? '');

  const conversation = conversations.find(c => c.id === conversationId);

  useEffect(() => {
    if (conversation?.student?.full_name) {
      navigation.setOptions({ title: conversation.student.full_name });
    }
  }, [conversation?.student?.full_name, navigation]);

  return <ConversationView conversationId={conversationId} />;
}
